import styled, { css } from 'styled-components';

// Import styles
import {
	flex,
	transitionMain,
	customMinResponsive,
	size,
	customResponsive
} from 'components/styles';

export const Container = styled.section`
	padding-top: 2rem;
	${flex({ jc: 'flex-start', fd: 'column' })}
	min-height: 100vh;
	position: relative;
	width: 100%;

	${({ isError }) =>
		isError &&
		css`
			justify-content: center;
		`}

	${customMinResponsive(
		size.medium,
		css`
			padding-top: 3.9rem;
			background-color: ${({ theme }) => theme.payment.background};
		`
	)};

	${customMinResponsive(
		size.large,
		css`
			padding-top: 7.9rem;
		`
	)};
`;

export const BackButton = styled.button`
	height: 3rem;
	position: absolute;
	top: 3.9rem;
	left: 6rem;
	background: transparent;
	border: none;
	cursor: pointer;

	svg {
		path {
			fill: ${({ theme }) => theme.payment.backButton};
		}

		line {
			stroke: ${({ theme }) => theme.payment.backButton};
		}

		path,
		line {
			${transitionMain}
		}
	}

	&:hover,
	&:focus {
		outline: none;

		svg {
			path {
				fill: ${({ theme }) => theme.payment.backButtonHover};
			}

			line {
				stroke: ${({ theme }) => theme.payment.backButtonHover};
			}
		}
	}

	${customResponsive(
		size.medium,
		css`
			display: none;
		`
	)}
`;

export const ErrorInfo = styled.p`
	color: ${({ theme }) => theme.white};
	padding: 0 20rem;
	font-size: 4.8rem;
	text-align: center;
`;
